module.exports = "/_next/static/images/9a537abdbbaf1290acc54dfc5d5517c9-slide-3-large.png";